import React, { useState } from "react";
import PropTypes from "prop-types";

import "../../../../../../components/AuthLayout/styles.css";
import "../../../../../../pages/signUp/styles.css";
import "./styles.css";

import ProgressBar from "../../../../../../pages/signUp/progressBar/ProgressBar";
import SelectLicensePlate from "../../../../../../pages/signUp/steps/SelectLicensePlate";
import VehicleData from "../../../../../../pages/signUp/steps/VehicleData";
import Confirmation from "../../../../../../pages/signUp/steps/Confirmation";
import { useNewVehicleForm } from "./useNewVehicleForm";

const STEPS = ["Placa", "Veículo", "Confirmação"];

// Mesmos passos e o mesmo visual do cadastro, dentro da moldura da garagem.
function WizardForm({ onSubmit, loading }) {
  const [page, setPage] = useState(1);
  const form = useNewVehicleForm({});

  function nextPage() {
    setPage(page + 1);
  }

  function previousPage() {
    setPage(page - 1);
  }

  const formProps = {
    ...form,
    nextPage,
    previousPage,
    onSubmit: () => onSubmit(form.values),
    loading,
    selectHeight: "50px",
  };

  return (
    <div className="gs-stack">
      <header className="gs-page-header">
        <span className="gs-eyebrow">Veículos</span>
        <h1>Adicionar à minha garagem</h1>
        <p>Informe a placa. Os atendimentos das empresas conectadas aparecem no histórico automaticamente.</p>
      </header>

      <div className="nv-wizard signup-page">
        <div className="auth-card">
          {/* Os passos avancam por botao; o submit so impede o Enter de recarregar a pagina. */}
          <form className="signup-form" onSubmit={(event) => event.preventDefault()} noValidate>
            <ProgressBar step={page} steps={STEPS} />
            {page === 1 && (
              <SelectLicensePlate {...{ ...formProps, previousPage: undefined }} />
            )}
            {page === 2 && <VehicleData {...formProps} />}
            {page === 3 && <Confirmation {...formProps} />}
          </form>
        </div>
      </div>
    </div>
  );
}

WizardForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

WizardForm.defaultProps = {
  loading: false,
};

export default WizardForm;
